import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CustomerDetails from './customer';
import ProductDetailsRepair from './ProductDetails_Repair';
import Modal from './Modal';
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Search from '../../../Assets/Icon search.svg'; // Assuming SearchIcon is in this folder
import Cookies from "js-cookie";
const ProductDetails = () => {
  const [warranties, setWarranties] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null);
  const [selectedCustomerRecords, setSelectedCustomerRecords] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const token = Cookies.get('admin');
  const fetchWarranties = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/awr/fetch`,
        {
          headers: {  "Content-Type": "application/json" ,
        "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
       },  
        });
      setWarranties(response.data);
      console.log("Response Data",response.data);
    } catch (error) {
      console.error('Error fetching warranties:', error);
    }
  };

  useEffect(() => {
    fetchWarranties();
  }, []);
  const updateStatus = async (productId, newStatus) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/admin/awr/update-status/${productId}`,
        { status: newStatus },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token ? `Bearer ${token}` : "",
          },
        }
      );
      if (response.status === 200) {
        alert('Status updated successfully');
      } else {
        console.error('Error updating status:', response.data.message);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  

  const fetchCustomerRecords = async (customerId) => {
    if (customerId) {
      try {
        const response = await axios.get(`${API_BASE_URL}/awr/customer/${customerId}`,
          {
            headers: {  "Content-Type": "application/json" ,
          "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
         },  
          });
        const productDetailsWithRepairs = response.data.map((record) => {
          if (record.productDetails) {
            return {
              ...record,
              productName: record.productDetails.productName,
         
              serialNo: record.productDetails.serialNo,
              modelNo: record.productDetails.modelNo,
              purchaseDate: record.productDetails.purchaseDate,
              expiryDate: record.productDetails.expiryDate,
              invoice: record.productDetails.invoice,
            };
          }
          return record;
        });
        setSelectedCustomerRecords(productDetailsWithRepairs);
      } catch (error) {
        console.error('Error fetching customer records:', error);
      }
    }
  };

  useEffect(() => {
    if (selectedCustomerId) {
      const fetchCustomerDetails = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/users/customer/${selectedCustomerId}`,
            {
              headers: {  "Content-Type": "application/json" ,
            "Authorization": token ? `Bearer ${token}` : "", // Add a space after `Bearer`
           },  
            });
          setSelectedCustomerDetails(response.data);
        } catch (error) {
          console.error('Error fetching customer details:', error);
        }
      };

      fetchCustomerDetails();
      fetchCustomerRecords(selectedCustomerId);
    }
  }, [selectedCustomerId]);

  const handleView = (customerId) => {
    setSelectedCustomerId(customerId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const getFirstLetter = (name) => name.charAt(0).toUpperCase();

  const getUniqueCustomers = (warranties) => {
    const uniqueCustomerMap = new Map();
    warranties.forEach((warranty) => {
      if (!uniqueCustomerMap.has(warranty.customerId)) {
        uniqueCustomerMap.set(warranty.customerId, warranty);
      }
    });
    return Array.from(uniqueCustomerMap.values());
  };

  const uniqueCustomers = getUniqueCustomers(warranties);

  // Filter customers based on search term
  const filteredCustomers = uniqueCustomers.filter((customer) => {
    const customerIdMatch = customer.customerId.toLowerCase().includes(searchTerm.toLowerCase());
    const customerNameMatch = customer.customerName.toLowerCase().includes(searchTerm.toLowerCase());
    return customerIdMatch || customerNameMatch;
  });

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleViewInvoice = (invoicePath) => {
    if (invoicePath === "N/A") {
      alert("Invoice not available.");
    } else {
      const invoiceUrl = `${API_BASE_URL}${invoicePath.replace(/\\/g, "/")}`;
      window.open(invoiceUrl, "_blank");
    }
  };
  

  return (
    <div className="p-6 min-h-screen rounded-lg">
      <div className="flex justify-between items-center mb-8 flex-wrap">
        <h1 className="text-3xl font-bold text-gray-800 w-full sm:w-auto">AWR Records</h1>
        {/* Search Input */}
        <div className="flex-shrink-0 w-full sm:w-1/3 relative mt-4 sm:mt-0">
          <input
            type="text"
            placeholder="Search Customer..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="p-2 pl-10 pr-3 rounded-lg w-full border border-gray-300 shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300"
          />
          <img
            src={Search}
            alt="Search Icon"
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6"
          />
        </div>
      </div>
      <div className="flex justify-between mb-4">
        <p className="font-semibold pl-4 text-[#87909A] hidden sm:block">Customer Name</p>
        <p className="font-semibold text-[#87909A] hidden sm:block pr-[240px]">Customer ID</p>
        <p className="font-semibold text-left text-[#87909A] hidden sm:block">Action</p>
      </div>


      <div className="container mx-auto">
        {currentCustomers.length > 0 ? (
          currentCustomers.map((customer, index) => (
            <div
              key={customer.customerId}
              className={`bg-white shadow-md rounded-lg p-4 mb-4 transition-all duration-300 ease-in-out transform ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } group hover:bg-gray-100 hover:scale-[1.02] hover:shadow-lg hover:cursor-pointer`}
            >
              <div className="flex justify-between items-center space-x-4 flex-wrap">
                {/* Circle with the first letter of the customer's name */}
                <div className="flex items-center space-x-3 w-1/2 sm:w-1/4">
                  <div className="w-7 h-7 bg-[#1C50A3] text-white rounded-full flex items-center justify-center font-bold group-hover:bg-blue-600">
                    {getFirstLetter(customer.customerName)}
                  </div>
                  <p className="text-[#292D32] font-semibold group-hover:text-blue-600">{customer.customerName}</p>
                </div>

                {/* Customer ID */}
                <p className="text-[#292D32] font-semibold w-1/2 sm:w-1/4 group-hover:text-blue-600">
                  {customer.customerId}
                </p>

                {/* Action button aligned to the right */}
                <div className="flex justify-end w-full sm:w-1/4 mt-4 sm:mt-0">
                  <button
                    onClick={() => handleView(customer.customerId)}
                    className="text-[#1C50A3] bg-[#E8F1FF] rounded-lg px-4 py-1 flex items-center space-x-2 transition duration-300"
                  >
                    <i className="fas fa-eye text-sm"></i> {/* FontAwesome Eye Icon */}
                    <span className="font-semibold">View</span>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="py-3 px-5 text-center text-gray-600">No customer found.</div>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-4 space-x-2">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`px-3 py-1 border rounded-md ${currentPage === 1 ? "text-gray-400" : "text-gray-700"
              }`}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              className={`px-3 py-1 border rounded-md ${currentPage === i + 1 ? "bg-blue-500 text-white" : "text-gray-700"
                }`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={`px-3 py-1 border rounded-md ${currentPage === totalPages ? "text-gray-400" : "text-gray-700"
              }`}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}


      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {selectedCustomerId && (
          <div className="">
            {selectedCustomerDetails && <CustomerDetails details={selectedCustomerDetails} />}
            <ProductDetailsRepair
              records={selectedCustomerRecords}
              updateStatus={updateStatus}
              formatDate={(dateString) => new Date(dateString).toLocaleDateString()}
              onViewInvoice={handleViewInvoice}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ProductDetails;
